import React from 'react';
import PropTypes from 'prop-types';

const StatCard = ({ icon: Icon, title, count, className }) => {
  return (
    <div className={`stat-card ${className}`}>
      <div className="stat-icon">
        <Icon />
      </div>
      <h2>{count}</h2>
      <p>{title}</p>
    </div>
  );
};

StatCard.propTypes = {
  icon: PropTypes.elementType.isRequired,
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  className: PropTypes.string
};

StatCard.defaultProps = {
  className: ''
};

export default StatCard;
